import { T } from "@repo/transifex";
import { type Currency } from "~/api/products/types";
import { cn } from "~/lib/utils";
import { priceFormatter } from "~/utils/price-formatter";

type OrdersTotalPriceProps = {
  currency: Currency;
  /** The payable total, deposits included. */
  unitPriceTotalInclVat: number;
  /** The deposits inside the total, shown apart when above zero. */
  depositTotalInclVat?: number;
  locale: string;
  isHighlighted: boolean;
};

export const OrdersTotalPrice = ({
  currency,
  unitPriceTotalInclVat,
  depositTotalInclVat = 0,
  locale,
  isHighlighted
}: OrdersTotalPriceProps) => {
  return (
    <div className="inline-flex flex-col items-end gap-1">
      {depositTotalInclVat > 0 ? (
        <span className="flex flex-row gap-3 px-6 text-base font-normal text-interface-neutral-5">
          <span>
            <T _str="Deposit" />
          </span>
          <span>
            {priceFormatter({ value: depositTotalInclVat, currency, locale })}
          </span>
        </span>
      ) : null}

      <div
        className={cn(
          "inline-flex flex-row items-center gap-3 rounded-full border-2 bg-interface-neutral-2 px-6 py-3 text-lg font-semibold",
          {
            "border-interface-negative-2 text-interface-negative-2":
              isHighlighted,
            "border-interface-neutral-6 text-interface-neutral-6":
              !isHighlighted
          }
        )}
      >
        <span>
          <T _str="Total" />
        </span>

        <span>
          {priceFormatter({
            value: unitPriceTotalInclVat,
            currency,
            locale
          })}
        </span>
      </div>
    </div>
  );
};
